module.exports = __webpack_public_path__ + "catalog/items/bench/bench.png";